export class BaseField {
	constructor(field, form) {
		this.field = field;
		this.form = form;
	}

	// Initialize the field
	init() {
		throw new Error("Field must implement init()");
	}

	// Handle form updates
	update() {
		// Optional method for fields that need to respond to form changes
	}
}
